import React from "react"
import Lightbox from "./Lightbox"
import { StaticQuery, graphql } from "gatsby"

const ALL_IMAGES = graphql`
  {
    getThumbsImages: allFile(filter: { absolutePath: { regex: "/gallery/" } }) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 500) {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
      }
    }
    getImages: allFile(filter: { absolutePath: { regex: "/gallery/" } }) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 1200) {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
      }
    }
  }
`

export default function Gallery() {
  return (
    <StaticQuery
      query={ALL_IMAGES}
      render={data => (
        <Lightbox
          thumbnails={data.getThumbsImages.edges}
          images={data.getImages.edges}
        />
      )}
    />
  )
}
